export default __webpack_public_path__ + "static/media/me.8a99eb36.png";